import clsx from "clsx";
import React from "react";

export const ButtonOpenMenu = ({ isOpen, setIsOpen }) => {
  return (
    <button
      type="button"
      onClick={() => setIsOpen(!isOpen)}
      className={clsx(
        "p-2 w-10 h-10 rounded-lg border transition-all duration-200",
        isOpen
          ? "bg-primary-100 text-primary-700 border-primary-300 hover:bg-primary-200"
          : "bg-background-100 text-text-600 border-text-300 hover:bg-background-200"
      )}
      title={isOpen ? "Fermer la section" : "Ouvrir la section"}
    >
      <span className="transition-all duration-200">{isOpen ? "▲" : "▼"}</span>
    </button>
  );
};
